// extracted by mini-css-extract-plugin
export default {"container":"Yq-z","heading":"Zq-z","text":"_q-z","info":"ar-z","link":"br-z","fullMaxWidth":"cr-z"};